var map = {
	"./Bank.png": 4234,
	"./Cubes.png": 7508,
	"./Dots.png": 148,
	"./Snow.png": 9833,
	"./a-delete.png": 5007,
	"./action-message.png": 9776,
	"./active-admin.png": 1552,
	"./admin-accounts-bg.png": 2836,
	"./admin-active-counselling.png": 6594,
	"./admin-alarm.png": 2119,
	"./admin-all-meet.png": 465,
	"./admin-avatar1.png": 660,
	"./admin-bible.png": 5602,
	"./admin-bin.png": 1383,
	"./admin-bin2.svg": 1255,
	"./admin-check-success.svg": 1994,
	"./admin-closed-counselling.png": 8452,
	"./admin-counselling.png": 5421,
	"./admin-crowd.svg": 7773,
	"./admin-dashboard-meetings.png": 7893,
	"./admin-dashboard-prayer-request.png": 5266,
	"./admin-dashboard-recordings.png": 9983,
	"./admin-devotional.png": 1075,
	"./admin-home-2.png": 9642,
	"./admin-logout.png": 5032,
	"./admin-message-notif.png": 5264,
	"./admin-prayer-meetings.png": 3188,
	"./admin-prayerreq.png": 2535,
	"./admin-prayerreq2.png": 9413,
	"./admin-profile-2user.png": 55,
	"./admin-recording.png": 1981,
	"./admin-roles.png": 99,
	"./admin-setting-2.png": 8713,
	"./admin-sign-out.png": 2078,
	"./admin-testimony-target.png": 8926,
	"./admin-testimony.png": 1718,
	"./admin-total-sessions.png": 1826,
	"./admin-upcoming-meet.png": 5302,
	"./african-american-male-friends.png": 5845,
	"./alarm.png": 1409,
	"./appStore-dark.png": 7483,
	"./appStore.png": 3816,
	"./arrow-right-blue.png": 3359,
	"./arrow-right.svg": 2188,
	"./arrow-square-down.png": 8664,
	"./avatar.svg": 6321,
	"./avatar1.png": 1269,
	"./avatar2.png": 38,
	"./avatar3.png": 5552,
	"./back.png": 1126,
	"./back.svg": 1963,
	"./bell-white.png": 5191,
	"./bg-signIn.png": 5522,
	"./boy-singing.png": 9284,
	"./calendar-2.png": 4475,
	"./calendar-2b.svg": 777,
	"./callIcon.svg": 2417,
	"./card-pos.png": 9435,
	"./cast-vote.png": 5220,
	"./church2.png": 4767,
	"./church3.png": 6022,
	"./close-circle-white.png": 6306,
	"./close-circle.png": 5353,
	"./cloud-upload-fill.png": 1109,
	"./concert2.png": 2676,
	"./connected.png": 6908,
	"./contactInfo.png": 7514,
	"./copyToClipboard.svg": 6020,
	"./counselling-chatbox.png": 3689,
	"./couselling-header.png": 3495,
	"./dancing-concert.png": 4643,
	"./devot-delete.svg": 9950,
	"./devot-edit.svg": 8947,
	"./dummy-avatar-logo copy.svg": 7035,
	"./dummy-avatar-logo.svg": 3732,
	"./editProfileBtn.png": 4957,
	"./email.png": 5738,
	"./facebook.svg": 6338,
	"./girl-with-mic.png": 5915,
	"./groupPeople.svg": 3946,
	"./home-2.png": 9948,
	"./hour-glass.png": 2313,
	"./inactive-admin.png": 7813,
	"./instagram.svg": 1574,
	"./joinUs.png": 7456,
	"./left-arrow.png": 1907,
	"./list.svg": 7050,
	"./location-minus.png": 622,
	"./location.svg": 9915,
	"./locationIcon.svg": 1420,
	"./logoP.jpg": 3941,
	"./man-holding-book.png": 8932,
	"./man-kissing-stomach.png": 8607,
	"./man-kneeling.png": 6608,
	"./manOfGod.png": 2059,
	"./markAnswered.png": 7838,
	"./medium-shot-people-praying.png": 4545,
	"./megaphone.png": 9372,
	"./message-notif.png": 862,
	"./microphone-2menu.png": 4088,
	"./more.png": 5871,
	"./moreContact.png": 6907,
	"./morePassword.png": 9668,
	"./moreSignOut.png": 2494,
	"./moreTestimonies.png": 5617,
	"./name_-gravity-_AdUs32i0jc-unsplash.jpg": 7016,
	"./notif-daily-devotional.png": 358,
	"./notif-meeting-starts.png": 5372,
	"./notif-new-recordings.png": 6484,
	"./notif-prayer-approved.png": 656,
	"./notif-testimony-approved.png": 8225,
	"./oldMan.png": 1073,
	"./oldWoman.png": 4351,
	"./padlock.png": 3584,
	"./phone.png": 2978,
	"./photorealistic-style-clouds-stairs2.jpg": 6866,
	"./playStore-dark.png": 5654,
	"./playStore.png": 8459,
	"./prayer-depot-logo.svg": 3014,
	"./prayerActive.svg": 6053,
	"./prayerAnswered.svg": 6946,
	"./praying-together.png": 7387,
	"./prayingMan.png": 8588,
	"./profile-inner.svg": 9970,
	"./profile2.png": 4547,
	"./profilePagePicture.png": 2932,
	"./recordingPageIcon.png": 1933,
	"./recordingtrumpet.png": 3432,
	"./requestSubmitted.png": 4158,
	"./right-arrow.png": 5164,
	"./right-gray.png": 6106,
	"./send-icon.png": 630,
	"./sendOtp.png": 1267,
	"./signOutPic.png": 7455,
	"./signnOut.svg": 6975,
	"./sms-star.svg": 1750,
	"./submittedAnonymously.png": 9199,
	"./success.png": 1727,
	"./sunset-background.png": 525,
	"./t-avatar1.png": 1061,
	"./t-avatar2.png": 5310,
	"./t-avatar3.png": 7799,
	"./t-avatar4.png": 8184,
	"./t-avatar5.png": 8401,
	"./testimoniesBg.png": 9809,
	"./text-copy.svg": 347,
	"./twitter.svg": 1663,
	"./video-circle2.png": 3486,
	"./video.png": 7339,
	"./videoMenu.png": 2534,
	"./welcomeToFamily.png": 1809,
	"./welcomeToFamily.svg": 3289,
	"./woman-on-the-altar.png": 1473,
	"./youngWoman.png": 5246,
	"./youtube.png": 4149
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;